exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".content[data-v-dcb45f5e]{padding-top:0;padding-bottom:20px}main[data-v-dcb45f5e]{box-shadow:5px 5px 25px 0 rgba(46,61,73,.2);background-color:#fff}.jumbotron[data-v-dcb45f5e]{background:linear-gradient(-90deg,#26aab2,#53d1af);color:#fff;border-radius:.3rem .3rem 0 0}#myProgress[data-v-dcb45f5e]{margin:0 14em;background-color:hsla(0,0%,100%,.3)}#myBar[data-v-dcb45f5e]{width:20%;height:.5em;background-color:#fff;color:#6ad5bf;font-weight:400}@media (max-width:575px){h2[data-v-dcb45f5e]{font-size:1.5em}#myBar[data-v-dcb45f5e]{height:.25em}#myProgress[data-v-dcb45f5e]{margin:0 6em}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-dcb45f5e","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/course/Course.vue
// module id = 220
// module chunks = 0